const livestreamingConst = {
  loadingCopywriting: [
    "Sit tight, she’s cumming",
    "Sliding into cleavage..",
    "Loading orgasms..",
    "Almost cumming..",
    "Waiting for her...",
    "Eat, pray, smash..loading",
    "Sexiness is loading...",
    "Loading love vibes...",
    "Loading sexiness..",
    "Something sexy awaits…",
    "Cooking orgasms..",
    "Something orgasmic is brewing..",
    "Finding love, almost there..",
    "Loading heat..",
    "Loading seduction..",
    "Loading playmates..",
    "Steamy moments incoming..",
    "Flirt, laugh, date.. Loading",
    "Playful stream loading..",
    "Ready, set, flirt.. loading",
  ],
  chatLimit: 80,
  config: {
    chatElement: {
      font: "700 0.9em Lato",
      desktopFontColor: "rgba(0, 0, 0, 0.87)",
      mobileFontColor: "#FFE18C",
      backgroundColor: "none",
    },
    giftElement: {
      font: "700 0.9em Lato",
      desktopFontColor: "rgba(0, 0, 0, 0.87)",
      mobileFontColor: "#FFE18C",
      backgroundColor: "rgba(13, 113, 65, 0.59)",
    },
    joiningElement: {
      font: "700 0.9em/1.4 Lato",
      desktopFontColor: "rgb(204 24 31/1)",
      mobileFontColor: "#FFE18C",
      backgroundColor: "none",
    },
    followingElement: {
      font: "700 0.9em/1.4 Lato",
      desktopFontColor: "rgb(80 179 67/1)",
      mobileFontColor: "#FFE18C",
      backgroundColor: "none",
    },
    emojiElement: {
      font: "700 0.9em Lato",
      desktopFontColor: "rgba(0, 0, 0, 0.87)",
      mobileFontColor: "#FFE18C",
      backgroundColor: "none",
    },
  },
};

export default livestreamingConst;
